import { Controller } from 'stimulus';
import { formatCurrency } from '@/js/shared/billables/currency';
import { decimal } from '@/js/shared/billables/decimal';

export default class extends Controller {
  static targets = [
    'row',
    'label',
    'calculatedAmount',
    'clearButton',
    'valueInput',
    'unit',
    'amountField',
    'percentageField',
    'enabledCheckbox',
  ];

  get calculationInput() {
    return {
      unit: this.unitTargets.find((unit) => unit.checked)?.value,
      value: this.valueInputTarget.value || '0',
    };
  }

  connect() {
    this.#syncInputState();
  }

  update() {
    this.#syncInputState();
    this.#broadcastChanged();
  }

  toggle() {
    this.rowTarget.classList.toggle('hide', !this.enabledCheckboxTarget.checked);
    this.resetDiscount();

    if (this.enabledCheckboxTarget.checked) {
      this.valueInputTarget.focus();
    }
  }

  resetDiscount() {
    this.valueInputTarget.value = '0.00';
    this.update();
  }

  clear() {
    if (this.hasEnabledCheckboxTarget) {
      this.enabledCheckboxTarget.checked = false;
      this.rowTarget.classList.add('hide');
    }

    this.resetDiscount();
  }

  renderCalculatedAmount({ discount, subtotal, currency }) {
    const discountAmount = decimal(discount);
    const subtotalAmount = decimal(subtotal);
    const formattedDiscount = formatCurrency(discount, currency);

    this.calculatedAmountTarget.textContent = discountAmount.gt('0')
      ? `-${formattedDiscount}`
      : formattedDiscount;
    this.valueInputTarget.classList.toggle('field--error', discountAmount.gt(subtotalAmount));
  }

  #syncInputState() {
    const { unit, value } = this.calculationInput;

    this.labelTarget.textContent =
      unit === 'percentage' ? `Discount (${decimal(value)}%):` : 'Discount:';
    this.clearButtonTarget.classList.toggle('hide', decimal(value).lte('0'));
    this.amountFieldTarget.value = unit === 'currency' ? value : 0;
    this.percentageFieldTarget.value = unit === 'percentage' ? value : 0;
  }

  #broadcastChanged() {
    this.dispatch('changed');
  }
}
